import { TableCell } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReportTable from "../../components/ReportTable";
import { ReportHeader } from "../../external/ensolvers-core-frontend-mui/dto/ReportDTO";
import NotificationService from "../../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/NotificationService";
import { WorklogMissingHours } from "../../models/WorklogMissingHours";
import WorkLogService from "../../services/WorkLogService";
import { AppToolbar } from "../AppToolbar";
import { AppContainerFullHeight } from "../AppContainerFullHeight";
import useTableHeight from "../../hooks/useTableHeight";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

export default function MissingHoursReport() {
  const { t } = useTranslation();

  const [headers, setHeaders] = useState<ReportHeader[]>();
  const [rows, setRows] = useState<WorklogMissingHours[]>([]);
  const { bottomSectionRef, calculateMaxHeight } = useTableHeight();
  const [filter, setFilter] = useState<boolean>(() => {
    const savedFilter = localStorage.getItem("missingHoursFilter");
    return savedFilter !== null ? JSON.parse(savedFilter) : false;
  });

  useEffect(() => {
    loadHeaders();
    getMissingHours();
  }, []);

  useEffect(() => {
    localStorage.setItem("missingHoursFilter", JSON.stringify(filter));
  }, [filter]);

  const loadHeaders = () => {
    let headers = new Array<ReportHeader>();
    headers.push({ label: "Project", align: "left" });
    headers.push({ label: "Days", align: "left" });
    headers.push({ label: "Total Hours", align: "left" });
    headers.push({ label: "Hours per member", align: "left" });
    setHeaders(headers);
  };

  const getMissingHours = () => {
    WorkLogService.getMissingHours()
      .then((response) => {
        setRows(response.getContentOrThrowError());
      })
      .catch((err) => NotificationService.error(err.message));
  };
  const handleFilter = () => {
    setFilter((prev) => !prev);
  };

  return (
    <>
      <AppContainerFullHeight
        bottomSectionRef={bottomSectionRef}
        topSection={<AppToolbar title={t("Worklog missing hours")} />}
        bottomSection={
          <>
            <FormGroup>
              <FormControlLabel
                sx={{ m: "0 0 10px 5px" }}
                control={<Checkbox checked={filter} sx={{ mr: "5px" }} onChange={handleFilter} />}
                label="List only projects with missing hours"
              />
            </FormGroup>
            <ReportTable<WorklogMissingHours>
              maxHeight={calculateMaxHeight(false)}
              stickyHeader
              headers={headers!}
              rows={filter ? rows.filter((r) => r.hours > 0) : rows}
              denseTable
              tableRow={(instance) => (
                <>
                  <TableCell>{instance.projectName}</TableCell>
                  <TableCell>{instance.days}</TableCell>
                  <TableCell>{instance.hours}</TableCell>
                  <TableCell>{instance.hoursPerMember}</TableCell>
                </>
              )}
            />
          </>
        }
      />
    </>
  );
}
